import React from 'react';

import { useTheme } from '@cobalt/react-theme-provider';
import Divider from '@cobalt/react-divider';
import Flex from '@cobalt/react-flex';
import Icon from '@cobalt/react-icon';
import Input from '@cobalt/react-input';

interface SelectSearchInputProps {
  searchValue: string;
  placeholder?: string;
  onChangeSearchValue: (value: string) => void;
}

const SelectSearchInput = (props: SelectSearchInputProps) => {
  const { searchValue, placeholder, onChangeSearchValue } = props;

  const theme = useTheme();

  return (
    <>
      <Flex paddingY="1" paddingX="2" alignY="center" height="40px">
        {/* Search icon */}
        <Flex padding="1">
          <Icon name="search" size="tiny" />
        </Flex>

        {/* Search input */}
        <Input
          data-testid="searchInput"
          value={searchValue}
          variation="unstyled"
          placeholder={placeholder}
          autoFocus
          onChange={(e) => onChangeSearchValue(e.target.value)}
        />

        {/* Clear icon */}
        {searchValue && (
          <Flex grow alignX="end" onClick={() => onChangeSearchValue('')}>
            <Icon name="clear" size="tiny" color={theme.gray600} />
          </Flex>
        )}
      </Flex>

      <Divider />
    </>
  );
};

export default SelectSearchInput;
